import * as React from "react"
import {Link as RouterLink} from "react-router-dom"
import {Link, useTheme} from "@mui/material"
import {ButtonIconSeeker} from "@ui-seeker/core"

import {REPRICING_ROUTES} from "@constants"


export default function RepricingNewAlertButton() {
	const { shadows, palette } = useTheme()

	return <Link component={RouterLink} to={REPRICING_ROUTES.FORM_PATH}>
		<ButtonIconSeeker
			icon="square-plus"
			iconWeight="thin"
			iconProps={{ fontSize: 70 }}
			sx={{ width: 1, height: 1, minHeight: 240, borderRadius: 2, boxShadow: shadows[2], color: palette.grey[400] }}
		/>
	</Link>
}